// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "PreviewIndicator-module--arrow-up-and-down--b91da";
export var container = "PreviewIndicator-module--container--9a99d";
export var indicatorIcon = "PreviewIndicator-module--indicatorIcon--bb151";